import React, { useContext, useEffect, useRef, useState } from "react";
import Clientclasses from "../../assets/css/ClientForm.module.css";
import { useHistory } from "react-router-dom";
import ReferenceDataContext from "AvatarContext";
import { Dialog, DialogContent, MenuItem, Select } from "@mui/material";
import NotificationAlert from "react-notification-alert";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import MaskedInput from "react-text-mask";
import { CustomerFormSchema } from "utils/schemas/CustomerFormSchema";
import { useFormik } from "formik";
import { AxiosAPiGet } from "AxiosAPi";
import { AxiosAPiPost } from "AxiosAPi";
import CustomerFormSkeleton from "./skeletons/CustomerFormSkeleton";
function EditCustomerForm({
  onCloseEditDialog,
  openEdit,
  editedCustomerId,
  fetchCustomersList,
}) {
  const history = useHistory();
  const notificationAlertRef = useRef(null);
  const { rolePermissions } = useContext(ReferenceDataContext);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingClientDataById, setLoadingClientDataById] = useState(false);
  const [getClientId, setGetClientId] = useState("");
  const isPermit = rolePermissions?.includes("clientList");
  const initialValues = {
    clientId: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    isActive: "",
  };
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues,
    validationSchema: CustomerFormSchema,
    enableReinitialize: true,
    onSubmit: (values, action) => {
      const data = {
        id: editedCustomerId,
        clientId: isPermit ? getClientId : values.clientId,
        firstName: values.first_name,
        lastName: values.last_name,
        email: values.email,
        phone: values.phone,
        isActive: values.isActive,
      };
      setLoadingButton(true);
      AxiosAPiPost(
        `${process.env.REACT_APP_AXIOS_BASE_URL}/customers/update`,
        "post",
        data,
        (response) => {
          if (response.data.status === true) {
            onAlertShow(response.data.message, "success");
            action.resetForm();
            setTimeout(() => {
              fetchCustomersList();
              onCloseEditDialog();
              setLoadingButton(false);
            }, 1000);
          } else {
            onAlertShow(response.data.message, "warning");
            setLoadingButton(false);
          }
        },
        history,
        (err) => {
          if (err.response.data.status === false) {
            setLoadingButton(false);
            if (err.response.status === 422) {
              if (err.response.data.errors.clientId) {
                onAlertShow(
                  err.response.data.errors.clientId.message,
                  "warning"
                );
              }
              if (err.response.data.errors.email) {
                onAlertShow(err.response.data.errors.email.message, "warning");
              }
            } else {
              onAlertShow(err.response.data.message, "warning");
            }
          }
        }
      );
    },
  });
  useEffect(() => {
    setLoading(true);
    AxiosAPiGet(
      `${process.env.REACT_APP_AXIOS_BASE_URL}/customers/view/${editedCustomerId}`,
      "get",
      (res) => {
        const { clientId, customer,subscription_status } = res.data.results.result;
        const { firstName, lastName, email, phone, isActive } = customer;

        if (isPermit) {
          setLoadingClientDataById(true);
          AxiosAPiGet(
            `${process.env.REACT_APP_AXIOS_BASE_URL}/clients/list?where_clause={"where_fields":["roles","clientId"],"where_values":["client",${clientId}]}`,
            "get",
            (res) => {
              if (res.status === 200) {
                const data = res.data.results.results.data;
                if (data.length > 0) {
                  setFieldValue(
                    "clientId",
                    data[0].hasOwnProperty("company_name")
                      ? data[0]?.company_name === "" ||
                        data[0]?.company_name === undefined ||
                        data[0]?.company_name === null
                        ? data[0]?.name === "" ||
                          data[0]?.name === undefined ||
                          data[0]?.name === null
                          ? `${data[0]?.first_name} ${data[0]?.last_name} (${clientId})`
                          : `${data[0]?.name} (${clientId})`
                        : `${data[0]?.company_name} (${clientId})`
                      : data[0]?.name === "" ||
                        data[0]?.name === undefined ||
                        data[0]?.name === null
                      ? `${data[0]?.first_name} ${data[0]?.last_name} (${clientId})`
                      : `${data[0]?.name} (${clientId})`
                  );
                  setFieldValue("first_name", firstName);
                  setFieldValue("last_name", lastName);
                  setFieldValue("email", email);
                  setFieldValue("phone", phone);
                  setFieldValue("isActive", subscription_status);
                  setGetClientId(clientId);
                  setLoadingClientDataById(false);
                  setLoading(false);
                } else {
                  setLoadingClientDataById(false);
                  setLoading(false);
                  return;
                }
              }
            },
            history,
            (err) => {
              onAlertShow(err.response.data.message, "warning");
              setLoading(false);
            }
          );
        } else {
          setFieldValue("clientId", clientId);
          setFieldValue("first_name", firstName);
          setFieldValue("last_name", lastName);
          setFieldValue("email", email);
          setFieldValue("phone", phone);
          setFieldValue("isActive", subscription_status);
          setLoading(false);
        }
      },
      history,
      (err) => {}
    );
  }, [history, editedCustomerId, setFieldValue, isPermit]);
  const onAlertShow = (msg, type) => {
    let options = {};
    options = {
      place: "tr",
      message: msg,
      type: type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 3,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  return (
    <div
      className={Clientclasses["client_form_content"]}
      onClick={() => {
        if (openDropdown) setOpenDropdown(false);
        return;
      }}
    >
      <Dialog
        open={openEdit}
        onClose={onCloseEditDialog}
        PaperProps={{
          style: {
            backgroundColor: "#fadf9e",
          },
        }}
      >
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>

        <DialogContent dividers className="px-0 px-sm-3 px-md-4">
          <div
            className={`popupForm-holder ${Clientclasses["dialog_content"]}`}
          >
            <Row>
              <Col md="12">
                <Form
                  id="RegisterValidation"
                  onSubmit={handleSubmit}
                  className="commonForm popupForm"
                >
                  <Card className="customColor6">
                    <CardHeader>
                      <CardTitle
                        className={`accordionHeaderColor labelText mb-0 ${Clientclasses["view_icon_cross"]}`}
                        tag="h4"
                      >
                        Edit Customer Form
                        <i
                          onClick={onCloseEditDialog}
                          className={`fa-solid fa-xmark ${Clientclasses["cursor_style"]}`}
                        ></i>
                      </CardTitle>
                    </CardHeader>
                    <CardBody>
                      {/* {isPermit && (
                        <FormGroup className="has-label">
                          <label className="darkText">
                            Client ID <span className="text-danger">*</span>
                          </label>
                          <CustomerFormSkeleton
                            loading={loading || loadingClientDataById}
                          >
                            <Input
                              name="clientId"
                              type="text"
                              min={1}
                              className={`bg-white`}
                              readOnly
                              value={values.clientId}
                              placeholder="Enter your client id"
                            />
                          </CustomerFormSkeleton>
                        </FormGroup>
                      )} */}

                      {/* <FormGroup className={`has-label`}>
                        <label className="darkText">
                          First Name <span className="text-danger">*</span>
                        </label>
                        <CustomerFormSkeleton
                          loading={loading || loadingClientDataById}
                        >
                          {" "}
                          <Input
                            name="first_name"
                            placeholder="Enter your first name"
                            type="text"
                            className="bg-white"
                            value={values.first_name}
                            onChange={handleChange}
                          />
                        </CustomerFormSkeleton>

                        {errors.first_name && touched.first_name ? (
                          <p className={Clientclasses["form_error"]}>
                            {errors.first_name}
                          </p>
                        ) : null}
                      </FormGroup> */}
                      {/* <FormGroup className={`has-label`}>
                        <label className="darkText">
                          Last Name <span className="text-danger">*</span>
                        </label>
                        <CustomerFormSkeleton
                          loading={loading || loadingClientDataById}
                        >
                          {" "}
                          <Input
                            name="last_name"
                            placeholder="Enter your last name"
                            type="text"
                            className="bg-white"
                            value={values.last_name}
                            onChange={handleChange}
                          />
                        </CustomerFormSkeleton>

                        {errors.last_name && touched.last_name ? (
                          <p className={Clientclasses["form_error"]}>
                            {errors.last_name}
                          </p>
                        ) : null}
                      </FormGroup> */}
                      <FormGroup className={`has-label`}>
                        <label className="darkText">
                          Email Address <span className="text-danger">*</span>
                        </label>
                        <CustomerFormSkeleton
                          loading={loading || loadingClientDataById}
                        >
                          <Input
                            name="email"
                            placeholder="Enter your email address"
                            type="email"
                            className="bg-white"
                            value={values.email}
                            onChange={handleChange}
                          />
                        </CustomerFormSkeleton>

                        {errors.email && touched.email ? (
                          <p className={Clientclasses["form_error"]}>
                            {errors.email}
                          </p>
                        ) : null}
                      </FormGroup>
                      {/* <FormGroup className={`has-label`}>
                        <label className="darkText">
                          Phone Number <span className="text-danger">*</span>
                        </label>
                        <CustomerFormSkeleton
                          loading={loading || loadingClientDataById}
                        >
                          <MaskedInput
                            mask={[
                              "(",
                              /[1-9]/,
                              /\d/,
                              /\d/,
                              ")",
                              " ",
                              /\d/,
                              /\d/,
                              /\d/,
                              "-",
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/,
                            ]}
                            className="form-control bg-white"
                            placeholder="Enter a phone number"
                            name="phone"
                            guide={true}
                            id="my-input-id"
                            value={values.phone}
                            onChange={(e) => {
                              setFieldValue(
                                "phone",
                                e.target.value.replace(/[^A-Z0-9]/gi, "")
                              );
                            }}
                            onBlur={handleBlur}
                          />
                        </CustomerFormSkeleton>

                        {errors.phone && touched.phone ? (
                          <p className={Clientclasses["form_error"]}>
                            {errors.phone}
                          </p>
                        ) : null}
                      </FormGroup> */}

                      <FormGroup className={`has-label`}>
                        <label className="darkText">
                         Subscription Status <span className="text-danger">*</span>
                        </label>
                        <CustomerFormSkeleton
                          loading={loading || loadingClientDataById}
                        >
                          <Select
                            name="isActive"
                            className={`w-100 bg-white ${Clientclasses["status_dropdown"]}`}
                            value={values.isActive}
                            onChange={handleChange}
                            displayEmpty
                          >
                            <MenuItem value="">Choose your Status</MenuItem>
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Inactive">Inactive</MenuItem>
                          </Select>
                        </CustomerFormSkeleton>

                        {errors.isActive && touched.isActive ? (
                          <p className={Clientclasses["form_error"]}>
                            {errors.isActive}
                          </p>
                        ) : null}
                      </FormGroup>
                    </CardBody>
                    <CardFooter className="text-center btn-set">
                      <Button color="info" type="submit">
                        {loadingButton ? "Processing..." : "Edit Customer"}
                      </Button>
                    </CardFooter>
                  </Card>
                </Form>
              </Col>
            </Row>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default EditCustomerForm;
